import { ReactElement, ReactNode } from 'react';
import Countries from '../pages/Countries/Countries';
import CountryCreation from '../pages/Countries/CountryCreation';
import CountryEdit from '../pages/Countries/CountryEdit';
import EmailCreation from '../pages/Emails/EmailCreation';
import EmailEdit from '../pages/Emails/EmailEdit';
import Emails from '../pages/Emails/Emails';
import Main from '../pages/Main/Main';
import OrganizationCreation from '../pages/Organizations/OrganizationCreation';
import OrganizationEdit from '../pages/Organizations/OrganizationEdit';
import Organizations from '../pages/Organizations/Organizations';
import Profile from '../pages/Profile/Profile';
import Submissions from '../pages/Submissions/Submissions';
import SurveyCreation from '../pages/Surveys/SurveyCreation';
import SurveyEdit from '../pages/Surveys/SurveyEdit';
import Surveys from '../pages/Surveys/Surveys';
import SurveySeriesEdit from '../pages/Surveys/SurveySeriesEdit';
import UserCreation from '../pages/Users/UserCreation';
import UserEdit from '../pages/Users/UserEdit';
import Users from '../pages/Users/Users';

interface PrivateRoutes {
  key: string;
  component: ReactElement;
  path?: string;
  index?: boolean;
  isAdmin?: boolean;
  element?: ReactNode;
}

export const PRIVATE_PATHS: PrivateRoutes[] = [
  { key: 'main', path: '/', component: <Main />, index: true },
  { key: 'survey-series-list', path: 'survey-series', component: <Surveys /> },
  {
    key: 'survey-series-id',
    path: 'survey-series/:seriesId',
    component: <SurveySeriesEdit />,
  },
  {
    key: 'survey-create',
    path: 'survey-series/:seriesId/survey/create',
    component: <SurveyCreation />,
    isAdmin: true,
  },
  {
    key: 'survey-filled-for-admin',
    path: 'survey-series/:seriesId/survey/:id/:organizationId',
    component: <SurveyEdit filledContent />,
    isAdmin: true,
  },
  {
    key: 'survey',
    path: 'survey-series/:seriesId/survey/:id',
    component: <SurveyEdit />,
  },
  {
    key: 'organizations',
    path: 'organizations',
    component: <Organizations />,
    isAdmin: true,
  },
  {
    key: 'organization-create',
    path: 'organizations/create',
    component: <OrganizationCreation />,
    isAdmin: true,
  },
  {
    key: 'organization-id',
    path: 'organizations/:organizationId',
    component: <OrganizationEdit />,
    isAdmin: true,
  },
  {
    key: 'users',
    path: 'users',
    component: <Users />,
    isAdmin: true,
  },
  {
    key: 'user-create',
    path: 'users/create',
    component: <UserCreation />,
    isAdmin: true,
  },
  {
    key: 'user-id',
    path: 'users/:userId',
    component: <UserEdit />,
    isAdmin: true,
  },
  {
    key: 'profile',
    path: 'profile',
    component: <Profile />,
  },
  {
    key: 'submissions',
    path: 'submissions',
    component: <Submissions />,
    isAdmin: true,
  },
  {
    key: 'emails',
    path: 'emails',
    component: <Emails />,
    isAdmin: true,
  },
  {
    key: 'email-create',
    path: 'emails/create',
    component: <EmailCreation />,
    isAdmin: true,
  },
  {
    key: 'email-id',
    path: 'emails/:emailId',
    component: <EmailEdit />,
  },
  {
    key: 'countries',
    path: 'countries',
    component: <Countries />,
    isAdmin: true,
  },
  {
    key: 'country-create',
    path: 'countries/create',
    component: <CountryCreation />,
    isAdmin: true,
  },
  {
    key: 'country-id',
    path: 'countries/:countryId',
    component: <CountryEdit />,
    isAdmin: true,
  },
];
